// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPSc4JyBoZWlnaHQ9JzgnPgogIDxyZWN0IHdpZHRoPSc4JyBoZWlnaHQ9JzgnIGZpbGw9JyNmZmYnLz4KICA8cGF0aCBkPSdNMCAwTDggOFpNOCAwTDAgOFonIHN0cm9rZS13aWR0aD0nMC41JyBzdHJva2U9JyNhYWEnLz4KPC9zdmc+Cg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Roboto", sans-serif; }

/* could probably done better with gradients. duplicated in: td.reserved */
.crosshatch .proposal,
.diagonal-stripe-1 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: repeat; }

/* .proposal-with-text { background-color: #eee; } */
.hex {
  text-align: left;
  color: khaki; }

a:link {
  text-decoration: none; }

a:visited {
  text-decoration: none; }

a:hover {
  text-decoration: none; }

a:active {
  text-decoration: none; }

#opcodes {
  border-collapse: collapse !important;
  table-layout: fixed;
  font-size: 9pt; }
  #opcodes td,
  #opcodes th {
    word-wrap: break-word;
    vertical-align: top;
    text-align: center; }
  #opcodes td {
    border: solid 1px #ccc;
    padding: 4px;
    background-clip: padding-box; }
  #opcodes td.reserved {
    background-color: #ccc;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: repeat;
    background-clip: padding-box;
    padding: 4px; }
  #opcodes .reserved span {
    color: darkgray;
    background-color: #eee; }
  #opcodes td:not(.reserved),
  #opcodes th {
    /*
	background-image: unset;
	background:white;
	background-clip: border-box;
	*/ }

.reserved-key {
  color: darkgray;
  background-color: #eee;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }

.op {
  font-size: larger;
  font-weight: bold;
  text-align: center; }

/* line break which doesn't get copied into clipboard */
.op::before {
  content: "\\A";
  white-space: pre; }

.post::before {
  content: "\\A";
  white-space: pre; }

.op-imm-args {
  font-family: Georgia, serif;
  font-size: 15px;
  padding-left: 0.8em; }

.op-type {
  padding-left: 0.8em; }

.op-type.large {
  font-size: large; }

.immediate-args {
  color: #e20c0c;
  font-family: Georgia, serif;
  font-style: italic; }

.mathsy {
  font-family: Georgia, serif; }

.mathsy-i {
  font-family: Georgia, serif;
  font-style: italic; }

.supsub {
  /* via https://stackoverflow.com/a/24908149 */
  display: inline-block; }

.supsub sup,
.supsub sub {
  position: relative;
  display: block;
  font-size: 0.5em;
  line-height: 1.2; }

.supsub sub {
  top: 0.3em; }

.highlight-selection {
  color: black;
  background-color: lightblue; }

.highlight-shorthand {
  background-color: #eee0ff; }

.highlight-opcode:not(.highlight-shorthand) {
  /* special colour for 'trunc' opcodes, when found outside of the selected "shorthand". */
  background-color: #cff1fc; }
  .highlight-opcode:not(.highlight-shorthand) td {
    color: #424242 !important; }

.highlight-opcode {
  background-color: #24dff0; }

.highlight-pre {
  background-color: rgba(219, 223, 16, 0.616); }

p.bigsign {
  font-size: 15.5pt;
  text-align: center; }

code,
pre,
.code {
  font-family: "Source Code Pro", monospace;
  padding: 0.2em 0.4em;
  margin: 0;
  font-size: 85%;
  background-color: #555555;
  border-radius: 6px; }
`, "",{"version":3,"sources":["webpack://./src/components/InstructionTable/style.scss"],"names":[],"mappings":"AAAA;EACE,iCAAiC,EAAA;;AAEnC,0EAAA;AACA;;EAEE,yDAAmS;EACnS,yBAAyB,EAAA;;AAG3B,oDAAA;AACA;EACE,gBAAgB;EAChB,YAAY,EAAA;;AAGd;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,oCAAoC;EACpC,mBAAmB;EAEnB,cAAc,EAAA;EAJhB;;IAQI,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB,EAAA;EAVtB;IAaI,sBAAsB;IAEtB,YAAY;IACZ,4BAA4B,EAAA;EAhBhC;IAoBI,sBAAsB;IACtB,yDAAmS;IACnS,yBAAyB;IACzB,4BAA4B;IAC5B,YAAY,EAAA;EAxBhB;IA2BI,eAAe;IACf,sBAAsB,EAAA;EA5B1B;;IAiCI;;;;EAXF,EAeC;;AAGH;EACE,eAAe;EACf,sBAAsB;EACtB,yDAAmS,EAAA;;AAErS;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB,EAAA;;AAEpB,uDAAA;AACA;EACE,aAAa;EACb,gBAAgB,EAAA;;AAElB;EACE,aAAa;EACb,gBAAgB,EAAA;;AAGlB;EACE,2BAA2B;EAC3B,eAAe;EACf,mBAAmB,EAAA;;AAGrB;EACE,mBAAmB,EAAA;;AAGrB;EACE,gBAAgB,EAAA;;AAGlB;EACE,cAAuB;EACvB,2BAA2B;EAC3B,kBAAkB,EAAA;;AAGpB;EACE,2BAA2B,EAAA;;AAE7B;EACE,2BAA2B;EAC3B,kBAAkB,EAAA;;AAGpB;EACE,6CAAA;EACA,qBAAqB,EAAA;;AAEvB;;EAEE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB,EAAA;;AAElB;EACE,UAAU,EAAA;;AAGZ;EACE,YAAY;EACZ,2BAA2B,EAAA;;AAE7B;EACE,yBAAyB,EAAA;;AAE3B;EACE,wFAAA;EACA,yBAAyB,EAAA;EAF3B;IAII,yBAAiC,EAAA;;AAGrC;EACE,yBAAyB,EAAA;;AAE3B;EACE,2CAA2C,EAAA;;AAE7C;EACE,iBAAiB;EACjB,kBAAkB,EAAA;;AAEpB;;;EAGE,yCAAyC;EACzC,oBAAoB;EACpB,SAAS;EACT,cAAc;EACd,yBAAyB;EACzB,kBAAkB,EAAA","sourcesContent":["body {\n  font-family: \"Roboto\", sans-serif;\n}\n/* could probably done better with gradients. duplicated in: td.reserved */\n.crosshatch .proposal,\n.diagonal-stripe-1 {\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPSc4JyBoZWlnaHQ9JzgnPgogIDxyZWN0IHdpZHRoPSc4JyBoZWlnaHQ9JzgnIGZpbGw9JyNmZmYnLz4KICA8cGF0aCBkPSdNMCAwTDggOFpNOCAwTDAgOFonIHN0cm9rZS13aWR0aD0nMC41JyBzdHJva2U9JyNhYWEnLz4KPC9zdmc+Cg==\");\n  background-repeat: repeat;\n}\n\n/* .proposal-with-text { background-color: #eee; } */\n.hex {\n  text-align: left;\n  color: khaki;\n}\n\na:link {\n  text-decoration: none;\n}\n\na:visited {\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: none;\n}\n\na:active {\n  text-decoration: none;\n}\n\n#opcodes {\n  border-collapse: collapse !important;\n  table-layout: fixed;\n  //   width: 336mm;\n  font-size: 9pt;\n\n  td,\n  th {\n    word-wrap: break-word;\n    vertical-align: top;\n    text-align: center;\n  }\n  td {\n    border: solid 1px #ccc;\n    //   color: #ececec;\n    padding: 4px;\n    background-clip: padding-box;\n  }\n\n  td.reserved {\n    background-color: #ccc;\n    background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPSc4JyBoZWlnaHQ9JzgnPgogIDxyZWN0IHdpZHRoPSc4JyBoZWlnaHQ9JzgnIGZpbGw9JyNmZmYnLz4KICA8cGF0aCBkPSdNMCAwTDggOFpNOCAwTDAgOFonIHN0cm9rZS13aWR0aD0nMC41JyBzdHJva2U9JyNhYWEnLz4KPC9zdmc+Cg==\");\n    background-repeat: repeat;\n    background-clip: padding-box;\n    padding: 4px;\n  }\n  .reserved span {\n    color: darkgray;\n    background-color: #eee;\n  }\n\n  td:not(.reserved),\n  th {\n    /*\n\tbackground-image: unset;\n\tbackground:white;\n\tbackground-clip: border-box;\n\t*/\n  }\n}\n.reserved-key {\n  color: darkgray;\n  background-color: #eee;\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPSc4JyBoZWlnaHQ9JzgnPgogIDxyZWN0IHdpZHRoPSc4JyBoZWlnaHQ9JzgnIGZpbGw9JyNmZmYnLz4KICA8cGF0aCBkPSdNMCAwTDggOFpNOCAwTDAgOFonIHN0cm9rZS13aWR0aD0nMC41JyBzdHJva2U9JyNhYWEnLz4KPC9zdmc+Cg==\");\n}\n.op {\n  font-size: larger;\n  font-weight: bold;\n  text-align: center;\n}\n/* line break which doesn't get copied into clipboard */\n.op::before {\n  content: \"\\A\";\n  white-space: pre;\n}\n.post::before {\n  content: \"\\A\";\n  white-space: pre;\n}\n\n.op-imm-args {\n  font-family: Georgia, serif;\n  font-size: 15px;\n  padding-left: 0.8em;\n}\n\n.op-type {\n  padding-left: 0.8em;\n}\n\n.op-type.large {\n  font-size: large;\n}\n\n.immediate-args {\n  color: rgb(226, 12, 12);\n  font-family: Georgia, serif;\n  font-style: italic;\n}\n\n.mathsy {\n  font-family: Georgia, serif;\n}\n.mathsy-i {\n  font-family: Georgia, serif;\n  font-style: italic;\n}\n\n.supsub {\n  /* via https://stackoverflow.com/a/24908149 */\n  display: inline-block;\n}\n.supsub sup,\n.supsub sub {\n  position: relative;\n  display: block;\n  font-size: 0.5em;\n  line-height: 1.2;\n}\n.supsub sub {\n  top: 0.3em;\n}\n\n.highlight-selection {\n  color: black;\n  background-color: lightblue;\n}\n.highlight-shorthand {\n  background-color: #eee0ff;\n}\n.highlight-opcode:not(.highlight-shorthand) {\n  /* special colour for 'trunc' opcodes, when found outside of the selected \"shorthand\". */\n  background-color: #cff1fc;\n  td {\n    color: rgb(66, 66, 66) !important;\n  }\n}\n.highlight-opcode {\n  background-color: #24dff0;\n}\n.highlight-pre {\n  background-color: rgba(219, 223, 16, 0.616);\n}\np.bigsign {\n  font-size: 15.5pt;\n  text-align: center;\n}\ncode,\npre,\n.code {\n  font-family: \"Source Code Pro\", monospace;\n  padding: 0.2em 0.4em;\n  margin: 0;\n  font-size: 85%;\n  background-color: #555555;\n  border-radius: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
